import { CiCalculator2 } from 'react-icons/ci';
import { MdInvertColors } from 'react-icons/md';
import { RiParentFill } from 'react-icons/ri';

import { CandleInfo } from '..';
import './index.css';
import {
  formatDate,
  formatPrice,
} from '../../../../../../../../helpers/NumberFormatter';
import { colors } from '../../../../../../../../colors';
import Checkbox from '../../../../../../../../components/Checkbox';

interface Props {
  density?: number;
  handleRaise?: () => void;
  handleLower?: () => void;
  candleInfo: CandleInfo | undefined;
  isCompare?: boolean;
  setIsCompare?: React.Dispatch<React.SetStateAction<boolean>>;
  showCompare?: boolean;
  enableWakeupTimeColor: boolean;
  toggleEnableWakeupTimeColor: React.Dispatch<React.SetStateAction<boolean>>;
  useParentIndicators: boolean;
  setUseParentIndicators: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChartDensityOptions = (props: Props) => {
  const {
    density,
    handleRaise,
    handleLower,
    candleInfo,
    isCompare,
    setIsCompare,
    showCompare,
    enableWakeupTimeColor,
    toggleEnableWakeupTimeColor,
    useParentIndicators,
    setUseParentIndicators,
  } = props;

  return (
    <div className="single-profit-calcs-chart-candle-info-root">
      <div className="single-profit-calcs-chart-density-options-root">
        {density && (
          <>
            <div
              className="single-profit-calcs-chart-density-options-item"
              onClick={handleLower}
            >
              <span className="single-profit-calcs-chart-density-options-text">
                -
              </span>
            </div>
            <div className="single-profit-calcs-chart-density-options-item single-profit-calcs-chart-density-options-item-middle">
              <span
                className="single-profit-calcs-chart-density-options-text"
                style={{ marginTop: -1 }}
              >
                {density}
              </span>
            </div>

            <div
              className="single-profit-calcs-chart-density-options-item"
              style={{ paddingLeft: 8 }}
              onClick={handleRaise}
            >
              <span className="single-profit-calcs-chart-density-options-text">
                +
              </span>
            </div>
          </>
        )}

        {showCompare && typeof isCompare !== 'undefined' && setIsCompare && (
          <div className="single-profit-calcs-chart-density-options-item-compare">
            {/** Icon */}
            <div className="single-profit-calcs-chart-density-icon">
              <CiCalculator2 color={colors.white} size={25} fontWeight={800} />
            </div>
            {/** Checkbox */}
            <Checkbox
              label={''}
              value={isCompare}
              handleValueChange={setIsCompare}
            />
          </div>
        )}

        <div className="single-profit-calcs-chart-density-options-item-compare">
          {/** Icon */}
          <div className="single-profit-calcs-chart-density-color-icon">
            <MdInvertColors color={colors.white} size={22} fontWeight={800} />
          </div>
          {/** Checkbox */}
          <Checkbox
            label={''}
            value={enableWakeupTimeColor}
            handleValueChange={toggleEnableWakeupTimeColor}
          />
        </div>

        <div className="single-profit-calcs-chart-density-options-item-compare">
          {/** Icon */}
          <div className="single-profit-calcs-chart-density-color-icon">
            <RiParentFill color={colors.white} size={22} fontWeight={800} />
          </div>
          {/** Checkbox */}
          <Checkbox
            label={''}
            value={useParentIndicators}
            handleValueChange={setUseParentIndicators}
          />
        </div>
      </div>

      {!!candleInfo && (
        <div className="single-profit-calcs-chart-candleview-info-container">
          <div className="single-profit-calcs-chart-candle-info-item">
            <span className="single-profit-calcs-chart-candle-info-item-label">
              Start:
            </span>
            <span className="single-profit-calcs-chart-candle-info-item-value">
              {formatDate(candleInfo.startTimestamp)}
            </span>
          </div>
          <div className="single-profit-calcs-chart-candle-info-item">
            <span className="single-profit-calcs-chart-candle-info-item-label">
              {candleInfo.direction === 'down' ? 'High:' : 'Low:'}
            </span>
            <span className="single-profit-calcs-chart-candle-info-item-value">
              {formatPrice(
                candleInfo.direction === 'down'
                  ? candleInfo.high
                  : candleInfo.low,
              )}
            </span>
          </div>
          <div className="single-profit-calcs-chart-candle-info-item">
            <span className="single-profit-calcs-chart-candle-info-item-label">
              {candleInfo.direction === 'down' ? 'Open:' : 'Close:'}
            </span>
            <span className="single-profit-calcs-chart-candle-info-item-value">
              {formatPrice(
                candleInfo.direction === 'down'
                  ? candleInfo.open
                  : candleInfo.close,
              )}
            </span>
          </div>
          <div className="single-profit-calcs-chart-candle-info-item">
            <span className="single-profit-calcs-chart-candle-info-item-label">
              {candleInfo.direction === 'down' ? 'Close:' : 'Open:'}
            </span>
            <span className="single-profit-calcs-chart-candle-info-item-value">
              {formatPrice(
                candleInfo.direction === 'down'
                  ? candleInfo.close
                  : candleInfo.open,
              )}
            </span>
          </div>
          <div className="single-profit-calcs-chart-candle-info-item">
            <span className="single-profit-calcs-chart-candle-info-item-label">
              {candleInfo.direction === 'down' ? 'Low:' : 'High:'}
            </span>
            <span className="single-profit-calcs-chart-candle-info-item-value">
              {formatPrice(
                candleInfo.direction === 'down'
                  ? candleInfo.low
                  : candleInfo.high,
              )}
            </span>
          </div>
          <div className="single-profit-calcs-chart-candle-info-item">
            <span className="single-profit-calcs-chart-candle-info-item-label">
              End:
            </span>
            <span className="single-profit-calcs-chart-candle-info-item-value">
              {formatDate(candleInfo.endTimestamp)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChartDensityOptions;
